import axios from 'axios'

const _axios = axios.create({
    baseURL: process.env.VUE_APP_SERVER_URL_INTEGRACAO,

    headers: { 
        'Content-Type': 'application/json'
    }
})

export default _axios